<agpr-take-over-panel
    [id]="id"
    class="agpr-manageSocialTopicsDialog"
    [showTopPadding]="false"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    (visibleChange)="closeDialog()"
    [width]="80"
    [footerContext]="'Social.intelligence.themeManagement.agent' | localize"
    [header]="'Social.manageTopicsDialog.heading'"
    [ariaLabel]="'Social.manageTopicsDialog.heading'"
>
    <div
        class="agpr-manageSocialTopicsDialog-content"
        [agprLoading]="loading"
    >
        <div class="agpr-manageSocialTopicsDialog-tablePanel">
            <div class="agpr-manageSocialTopicsDialog-quotaExceededBanner">
                <agpr-quota-exceeded-banner></agpr-quota-exceeded-banner>
            </div>
            <agpr-scroll-panel
                class="agpr-manageSocialTopicsDialog-scrollPanel"
            >
                <agpr-social-table
                    [id]="id + '_table'"
                    [columns]="columnDefs"
                    [sortColumn]="nameColumn"
                    [sortAscending]="true"
                    [(ngModel)]="dataRows"
                    [vsItemSize]="63"
                    [vsMinBufferPx]="350"
                    [vsMaxBufferPx]="700"
                    (ngModelChange)="checkForSelected()"
                    (itemChanged)="rowChanged($event)"
                ></agpr-social-table>
            </agpr-scroll-panel>
        </div>
    </div>

    <ng-template #takeOverFooterRight>
        <agpr-button
            [id]="id + '_createTopic'"
            class="agpr-manageSocialTopicsDialog-createTopicButton"
            [style]="buttonTypes.primaryB"
            (click)="openAgentWidget()"
            label="Social.intelligence.themeManagement.themeCard.addAgent.createAgent"
        ></agpr-button>
        @if (selectedTopics.length > 0) {
            <agpr-button
                [id]="id + '_addToThemeDialogButton'"
                label="Social.manageTopicsDialog.addToTheme"
                (click)="openAddToThemeDialog()"
                [style]="buttonTypes.primaryB"
            ></agpr-button>
        }

        <agpr-button
            [id]="id + '_confirmButton'"
            label="done"
            (click)="closeDialog()"
            [style]="buttonTypes.primary"
        ></agpr-button>
    </ng-template>
</agpr-take-over-panel>

<ng-template #nameCell let-row="row" let-column="column">
    <div class="agpr-manageSocialTopicsDialog-nameCell">
        <span
            class="agpr-manageSocialTopicsDialog-nameCell-name"
            [pTooltip]="row[column.field]"
        >
            {{ row[column.field] }}
        </span>
        <!-- An automation agent is watching this topic -->
        @if (liveAgentCount(row)) {
            <span
                role="img"
                class="agpr-manageSocialTopicsDialog-nameCell-liveAgentIcon fa-solid fa-signal-stream"
                [pTooltip]="liveAgentTooltip(row)"
                tooltipPosition="top"
                [attr.aria-label]="liveAgentTooltip(row)"
            ></span>
        }
    </div>
</ng-template>

<ng-template #statusCell let-row="row" let-column="column">
    <div class="agpr-manageSocialTopicsDialog-statusCell">
        <agpr-social-topic-status-switch
            [id]="id + '_' + row.originalData?.id + '_socialTopicsManageDialog_statusCell'"
            [initiallyFocusable]="false"
            [(ngModel)]="row[column.field]"
            (ngModelChange)="rowChanged(row)"
            [disabled]="row?.themeList?.length === 0 || row?.agentNetworks?.length === 0"
            [disabledTooltip]="row?.themeList?.length === 0
                ? 'Social.agentWidget.error.noTheme'
                : row?.agentNetworks?.length === 0
                ? 'Social.agentWidget.error.noNetwork'
                : null"
            [agentName]="row?.name"
            [isPartiallyModerated]="row.isPartiallyModerated"
            [partiallyModeratedTooltip]="'Social.intelligence.themeManagement.themeCard.partiallyModerated' | localize: {
                rowName: row.name,
                moderatedNetworks: row.partiallyModeratedNetworks
            }"
        ></agpr-social-topic-status-switch>
    </div>
</ng-template>

<ng-template #themeListCell let-row="row" let-column="column">
    <div class="agpr-manageSocialTopicsDialog-themeListCell">
        @if (row[column.field] && row[column.field].length > 0) {
            <agpr-chip-container
                [id]="id + '_' + row.originalData?.id + '_socialTopicsManageDialog_themeListCell'"
                [chips]="row[column.field]"
                (removeChip)="deleteThemeChip($event, row)"
                [style]="agprComponentStyle.social"
                [wrapChips]="false"
                [isInTable]="true"
            ></agpr-chip-container>
        }

        <div class="agpr-manageSocialTopicsDialog-themeListCell-autocomplete">
            @if (row['selected'] === true) {
                <agpr-autocomplete
                    #themeAutocomplete
                    [id]="id + '_' + row.originalData?.id + '_themeAutoComplete'"
                    labelField="name"
                    [placeholder]="'Social.manageTopicsDialog.addToTheme'"
                    [dropdown]="true"
                    [isInTable]="true"
                    [(ngModel)]="row['selectedTheme']"
                    (itemSelected)="selectTheme($event, row)"
                    (onKeyUp)="$event?.stopPropagation()"
                    [suggestions]="row['suggestions']"
                    [multiSelection]="false"
                    [ariaLabel]="'Social.manageTopicsDialog.addToTheme'"
                ></agpr-autocomplete>
            }
        </div>
    </div>
</ng-template>

<ng-template #actionsCell let-row="row">
    <div class="agpr-manageSocialTopicsDialog-actionsCell">
        <!-- Who made the topic and when, kept beside the actions it belongs with -->
        <span
            role="img"
            class="fa-regular fa-circle-info agpr-manageSocialTopicsDialog-actionsCell-infoIcon"
            [agprTooltip]="'Source.manageDialog.sourceInformation' | localize : {
                createdDate: row.createdDate,
                createdBy: row.createdByUser,
                modifiedDate: row.lastModifiedDate,
                modifiedBy: row.lastModifiedByUser
            }"
            tooltipPosition="left"
            [initiallyFocusable]="false"
        ></span>
        <agpr-kebab-menu
            [id]="id + '_socialTopicActions'"
            [options]="rowOptions"
            [data]="row"
            [showIcon]="true"
            textAlignment="right"
            [initiallyFocusable]="false"
            [ariaLabel]="'Social.manageTopicsDialog.actions' | localize"
            panelPositionX="left"
        ></agpr-kebab-menu>
    </div>
</ng-template>
